<!--
 - Author : wanghongling.
 - Date   : 2019/5/28.
 - File   : yuJNewest.最新预警
 -->

<template>
  <div class="yuj-newest">
    <layer title="最新预警" width="410px">
      <!--<ul :class="['yuj-list', getViewPer==='1'?'mh160':'mh586']"  v-if="list && list.length>0">-->
      <ul :class="['yuj-list', getViewPer==='1'?'mh160':'mh160']"  v-if="list && list.length>0">
        <li :class="['yuj-list-item', (index===0&&newShow)?'dyt':'']"
            v-for="(item, index) in list"
            :key="index"
            @click="showRegion(item)">
          <el-tooltip class="item" effect="light"
              :content="`${item.departmentName}${item.regionName||''}${item.deviceName}${item.content}`"
              placement="right">
            <div class="yuj-list-item-left">{{item.departmentName}}{{item.regionName||''}}{{item.deviceName}}{{item.content}}
            </div>
          </el-tooltip>
          <div class="yuj-list-item-right">{{item.occurrenceTime}}</div>
        </li>
      </ul>
      <!--<div :class="['no-the-data', getViewPer==='1'?'h155':'h580']" v-if="list && list.length===0">-->
      <div :class="['no-the-data', getViewPer==='1'?'h155':'h155']" v-if="list && list.length===0">
        <div>
          <i class="iconfont icon-content-likes dzi"></i>
          <p>暂无最新预警</p>
        </div>
      </div>
    </layer>
    <!--首页显示相应异常详情弹窗-->
    <Popover title="异常信息" width="560px" @closeEvent="indexRegion = false"  v-if="indexRegion" class="index-region">
      <!--异常信息详情-->
      <div v-if="current.exceptionImageUrl" class="detail-img" @click="showPic(current.exceptionImageUrl)">
        <img :src="current.exceptionImageUrl">
      </div>
      <div class="detail-r" :style="{width: current.exceptionImageUrl?'38%':'100%'}">
        <p><span class="detail-tit" v-show="current.deviceName">设备名称 </span><span class="detail-ct">{{current.deviceName}}</span></p>
        <p>
          <span class="detail-tit">所属食堂： </span>
          <span class="detail-ct">{{current.deptName}}</span>
        </p>
        <p>
          <span class="detail-tit">所属点位： </span>
          <span class="detail-ct">{{current.anchorName||'无'}}</span>
        </p>
        <p>
          <span class="detail-tit">所属区域：</span>
          <span class="detail-ct">{{current.regionName||'无'}}</span>
        </p>
        <p>
          <span class="detail-tit">异常类型：</span>
          <span class="detail-ct">{{current.anomalousTypeName||'无'}}</span>
        </p>
        <p>
          <span class="detail-tit">异常时间：</span>
          <span class="detail-ct">{{current.occurrenceTime||'无'}}</span>
        </p>
        <p class="detail-tit">告警内容 </p>
        <p class="detail-ct">{{current.content}}</p>
      </div>
    </Popover>
  </div>
</template>

<script>
export default {
  name: 'yuJNewest',
  data () {
    return {
      list: [],
      imgUrl: this.$store.getters.fileApi,
      orgId: this.$store.getters.userInfo.orgId,
      // cameraImgUrl: window.localStorage.getItem('cameraImgUrl'),
      indexRegion: false,
      newShow: false,
      current: {},
      states: null
    }
  },
  props: {
    selectOrgId: {}
  },
  watch: {
    getViewPer: {
      handler: function () {
        this.getExceptionNewList()
      },
      immediate: true,
      deep: true
    },
    selectOrgId: {
      handler(cur) {
        this.orgId = cur
        this.indexRegion = false
        this.getExceptionNewList()
      },
      deep: true
    }
  },
  computed: {
    getViewPer() {
      return this.$store.getters.viewList.e002
    }
  },
  mounted() {
    this.onWebsocketMsg()
  },
  methods: {
    /**
     * @Description:查看详情
     * @author wanghongling
     * @createDate 2019/12/23
    */
    showRegion(item) {
      this.indexRegion = true
      this.regionExceptionInfo(item.exceptionId)
    },
    /**
     * 显示查看图片框
     * @author: whl
     * @createDate: 2019/6/21
     * @param item 图片信息
     * @return {Object}
     */
    showPic (item) {
      this.$superMessage('查看图片', '', {imgPic: item, btnShow: false}).then(() => {
        // do something
      }).catch(() => {
        // do something
      })
    },
    /**
     * 获取异常信息详情调用接口
     * @author: whl
     * @param exceptionId 异常id
     * @createDate: 2019/6/14
     */
    regionExceptionInfo (exceptionId) {
      this.current = {}
      this.$request.regionExceptionInfoGet({exceptionId}).then(res => {
        console.log('res!!!!', res)
        this.current = res
        this.$set(this.current, 'exceptionImageUrl', res.fileList[0] ? this.imgUrl + res.fileList[0] : '')
        this.$request.fileExceptionPrtscreenListGet({targetId: exceptionId}).then(res => {
          console.log('根据id获取图片', res)
          this.$set(this.current, 'fileList', res)
        }).catch(e => {
          console.error(e)
        })
      }).catch(e => {
        console.error(e)
      })
    },
    /**
     * @author wanghongling
     * @createTime 2019/06/19
     * @param name
     * @param item
     * @description 页面跳转
     */
    turnTo(name, item) {
      this.$emit('turnTo', name, item.departmentId, item.departmentName, 1, item.exceptionId)
    },
    /**
     * @author wanghongling
     * @createTime 2019/06/19
     * @description 获取最新异常信息
     */
    getExceptionNewList () {
      // let pageSize = (this.getViewPer === '1') ? 8 : 16
      let pageSize = 5
      let param = {
        orgId: this.orgId,
        page: 1,
        pageSize: pageSize
      }
      this.newShow = false
      this.list = []
      this.$request.exceptionNewListGet(param).then(response => {
        if (!this.$utils.isEmptyObject(response)) {
          this.list = response
          this.newShow = true

          if(this.list && this.websocketNotify) {

            let exceptionId = response[0].exceptionId

            this.$request.regionExceptionInfoGet({exceptionId}).then(res=>{
              if(!res) {
                return
              }
              if(res.fileList && res.fileList.length>0) {
                res.exceptionImageUrl = this.imgUrl+res.fileList[0]
              }
              this.$emit('updateMsgBoxSingleContent',res)

            }).catch(ex => {
              console.error(ex)
            })
          }
          this.websocketNotify = false
        }
      }).catch(e => {
        console.error(e)
        this.newShow = true
      })
    },
    /**
     * @author wanghongling
     * @createTime 2019/06/19
     * @description websocket监听数据
     */
    onWebsocketMsg () {
      window.getYuJNewest = e => {
        this.websocketNotify = true
        console.log(e, 'websocket监听数据')
        this.getExceptionNewList()
      }
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
  @import '../../assets/less/color';
  .yuj-newest{
    padding-bottom: 15px;
    .mh586{
      min-height: 540px;
    }
    .mh160{
      min-height: 160px;
    }
    .yuj-list{
      &-item{
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding-top: 5px;
        margin-bottom: 10px;
        cursor: pointer;
        &-left{
          font-size: 14px;
          color: @lightBlue;
          width: 240px;
          word-break: break-all;
          overflow: hidden;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
          white-space:nowrap;
        }
        &-right{
          font-size: 12px;
          color: @lightGrey;
        }
      }
      &-item:hover{
        .yuj-list-item-left{
          color: #fff;
        }
      }
      &-item:last-child{
        margin-bottom: 5px;
      }
    }
    .dyt{
      -webkit-animation: trianglePop1 2.5s;
      animation: trianglePop1 2.5s;
    }
    .index-region{
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .detail-img {
        display: inline-block;
        width: 60%;
        vertical-align: top;
        cursor: pointer;

        img {
          width: 95%;
        }
      }
      .detail-r {
        display: inline-block;
        width: 38%;
        font-size: 14px;

        .detail-tit {
          color: @darkBlue;
          line-height: 30px;
        }

        .detail-ct {
          color: @lightBlue;
        }
      }
    }
    @keyframes trianglePop1 {
      0% {
        font-weight: bolder;
        transform: scale(1.1) translateY(-20px);
      }
      35% {
        font-weight: bolder;
        transform: scale(1) translateY(-10px)
      }
      60% {
        font-weight: bolder;
        transform: scale(1.1) translateY(-5px)
      }
      100% {
        font-weight: bolder;
        transform: scale(1) translateY(0)
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/yuJNewest.vue